import React from "react";
import Card from "../../../../components/Card";
import Pager from "../../../../components/Pager";
import {Form, Formik} from "formik";
import Translate from "../../../../components/Translate";
import NsAccordion from "../../../../components/accordion/NsAccordion";
import NsDatePicker from "../../../../components/NsDatePicker";
import TabellaCertDocumentiFirmatiController from "./tabella_cert_doc_firmati/TabellaCertDocumentiFirmatiController";

export default function ListDocumentiFirmatiView({
                                                     documentiFirmati,
                                                     totDocumentiFirmati,
                                                     getDocumentiFirmati,
                                                     filtro,
                                                     setFiltro,
                                                     initFiltro,
                                                     tipiCertificato,
                                                     loadingData,
                                                     pagina,
                                                     totPagine,
                                                     cambioPagina,
                                                     handlerUpdateCertificati,
                                                 }) {

    return (
        <Card
            icon={'fas fa-signature'}
            title={'Archivio documenti firmati'}
        >
            <div className={"row mb-4"}>
                <div className={"col-md-12"}>
                    <Formik
                        onSubmit={getDocumentiFirmati}
                        initialValues={{}}>
                        <Form>
                            <div className={'row pb-2'}>
                                <div className={'col-md-2'}>
                                    <input
                                        type={"text"}
                                        id={"nominativo"}
                                        className="form-control"
                                        placeholder={"Nome/Cognome socio"}
                                        value={filtro.nominativo}
                                        onChange={(ev) => {
                                            setFiltro(prevState => ({...prevState, "nominativo": ev.target.value}));
                                        }}/>
                                </div>
                                <div className={'col-md-4'}>
                                    <button type={"submit"} className={"btn btn-dark"}>
                                        <i className="fas fa-search"></i> <Translate>Cerca</Translate>
                                    </button>
                                    <button type="button" className={"btn btn-dark"} onClick={() => {
                                        initFiltro();
                                    }}>
                                        <i className="fas fa-trash"></i> <Translate>Azzera filtri</Translate>
                                    </button>
                                </div>
                            </div>
                            <NsAccordion
                                titolo={'Filtri'}
                                label={'fas fa-filter'}
                                defaultKey={""}
                            >
                                <div className={'row'}>
                                    <div className={'col-md-2'}>
                                        <label htmlFor={"targa"}>Targa:</label>
                                        <input
                                            type={"text"}
                                            id={"targa"}
                                            className="form-control"
                                            value={filtro.targa}
                                            onChange={(ev) => {
                                                setFiltro(prevState => ({...prevState, "targa": ev.target.value}));
                                            }}/>
                                    </div>
                                    <div className={'col-md-2'}>
                                        <label htmlFor={"marca"}>Marca:</label>
                                        <input
                                            type={"text"}
                                            id={"marca"}
                                            className="form-control"
                                            value={filtro.marca}
                                            onChange={(ev) => {
                                                setFiltro(prevState => ({...prevState, "marca": ev.target.value}));
                                            }}/>
                                    </div>
                                    <div className={'col-md-2'}>
                                        <label htmlFor={"tipo"}>Tipo veicolo:</label>
                                        <input
                                            type={"text"}
                                            id={"tipo"}
                                            className="form-control"
                                            value={filtro.tipo}
                                            onChange={(ev) => {
                                                setFiltro(prevState => ({...prevState, "tipo": ev.target.value}));
                                            }}/>
                                    </div>
                                    <div className={'col-md-6'}>
                                        <label htmlFor={"id_tipo_certificato"}>Tipo Certificato:</label>
                                        <select
                                            id={"tipo"}
                                            className="form-control form-select"
                                            value={filtro.id_tipo_certificato}
                                            onChange={(ev) => {
                                                setFiltro(prevState => ({
                                                    ...prevState,
                                                    "id_tipo_certificato": ev.target.value
                                                }));
                                            }}>
                                            <option value={""}>Tutti i tipi</option>
                                            {
                                                tipiCertificato && tipiCertificato.map(tc =>
                                                    <option value={tc.id_tipo_certificato}
                                                            key={tc.id_tipo_certificato}>{tc.nome}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className={'col-md-2'}>
                                        <label htmlFor={"data_pagamento_da"}>Data pagamento dal:</label>
                                        <NsDatePicker
                                            nome={"data_pagamento_da"}
                                            dataSelezionata={filtro.data_pagamento_da}
                                            maxDate={filtro.data_pagamento_da}
                                            setSelectedDate={(date, event) => {
                                                setFiltro(prevState => ({...prevState, "data_pagamento_da": date}));
                                            }}
                                        />
                                    </div>
                                    <div className={'col-md-2'}>
                                        <label htmlFor={"data_pagamento_a"}>Data pagamento al:</label>
                                        <NsDatePicker
                                            nome={"data_pagamento_a"}
                                            dataSelezionata={filtro.data_pagamento_a}
                                            minDate={filtro.data_pagamento_a}
                                            setSelectedDate={(date, event) => {
                                                setFiltro(prevState => ({...prevState, "data_pagamento_a": date}));
                                            }}
                                        />
                                    </div>
                                    <div className={'col-md-2'}>
                                        <label htmlFor={"data_registrazione_da"}>Registrazione dal:</label>
                                        <NsDatePicker
                                            nome={"data_registrazione_da"}
                                            dataSelezionata={filtro.data_registrazione_da}
                                            maxDate={filtro.data_registrazione_da}
                                            setSelectedDate={(date, event) => {
                                                setFiltro(prevState => ({...prevState, "data_registrazione_da": date}));
                                            }}
                                        />
                                    </div>
                                    <div className={'col-md-2'}>
                                        <label htmlFor={"data_registrazione_a"}>Registrazione al:</label>
                                        <NsDatePicker
                                            nome={"data_registrazione_a"}
                                            dataSelezionata={filtro.data_registrazione_a}
                                            minDate={filtro.data_registrazione_a}
                                            setSelectedDate={(date, event) => {
                                                setFiltro(prevState => ({...prevState, "data_registrazione_a": date}));
                                            }}
                                        />
                                    </div>
                                </div>
                            </NsAccordion>
                        </Form>
                    </Formik>
                </div>
            </div>
            {
                loadingData ? (
                    <p>Caricamento in corso...</p>
                ) : (
                    <TabellaCertDocumentiFirmatiController
                        documentiFirmati={documentiFirmati}
                        totDocumentiFirmati={totDocumentiFirmati}
                        handlerUpdateCertificati={handlerUpdateCertificati}
                    />
                )}
            {
                totPagine &&
                <Pager
                    pagina={pagina}
                    totale={totPagine}
                    handlerCambioPagina={cambioPagina}
                />
            }
        </Card>
    );
}